import React, {useEffect,useContext,useState,useRef} from "react";
import { useNavigate, useLocation,useParams  } from 'react-router-dom';

import { Link } from 'react-router-dom';


import Context from '../context/context';

const config = require("../_helpers/configServizi"); 


export default function Navbar_mobile_new(props) {
	
    let navigate = useNavigate();
    const context = useContext(Context);	

    const [activeIndex, setActiveIndex] = useState(0);
    const [versioneInviti, setVersioneInviti] = useState(context.flusso.messaggi_inviti);
    const [elementiMenu, setelementiMenu] = useState(elementi_menu());
    const menuRef = useRef(null);
    const menuBorderRef = useRef(null);
    
   
   
    function elementi_menu(){
      if(!context.flusso.messaggi_inviti){
        return ["find","match","chats","notifications","profile"]
      }else{
        return ["match","chats","notifications","profile"]
      }
    }


    function searchIndex(page){
      return elementiMenu.indexOf(page)
    }
    
    
    let params = useParams();
	
    useEffect(() => {
      setelementiMenu(elementi_menu())
    },[context.flusso.messaggi_inviti])

  
    useEffect(() => {

        if(menuRef.current){
          const body = document.body;
            
            offsetMenuBorder(menuRef.current.querySelector('.active'), menuBorderRef.current);
        
            const handleResize = () => {
                offsetMenuBorder(menuRef.current.querySelector('.active'), menuBorderRef.current);
                menuRef.current.style.setProperty("--timeOut", "none");
            };
        
            window.addEventListener('resize', handleResize);
        
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
            
    }, [activeIndex]);


    useEffect(() => {

      if((location[1]=="chats" && location[2]!=undefined)){
        setActiveIndex(searchIndex("chats"))
        return
      }if(location[1]=="chats" && location[2] == undefined){
        setActiveIndex(searchIndex("chats"))
        return
      }if(location[1]=="notifications"){
        setActiveIndex(searchIndex("notifications"))
        return
      }if(location[1]=="profile"){
        setActiveIndex(searchIndex("profile"))
        return
      }if(location[1]=="find"){
        setActiveIndex(searchIndex("find"))
        return
      }if(location[1]=="match"){
        setActiveIndex(searchIndex("match"))
        return
      }

      setActiveIndex(null)

    },[params])

  
    const offsetMenuBorder = (element, menuBorder) => {
        if(element){
            const offsetActiveItem = element.getBoundingClientRect();
            const left = Math.floor(offsetActiveItem.left - menuRef.current.offsetLeft - (menuBorder.offsetWidth - offsetActiveItem.width) / 2) + "px";
            menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
        }
      
    };
  
    const handleClick = (index,elemento) => {
       
      if (activeIndex !== index) {
        setActiveIndex(index);
      }

      switch(elemento){
        case "find":
            navigate('/find');
            break;
        case "match":
            navigate('/match');
            break;
        case "chats":
            navigate('/chats');
            break;
        case "notifications":
            navigate('/notifications');
            break;
        case "profile":
            navigate('/profile');
            break;
      }
    };





  
	
	


	var location = useLocation();
    location = location.pathname.split("/")

	const domain = window.location.hostname;


   /* if((location[1] == "purchase") || (location[1]=="chats" && location[2]!=undefined)){
        return (<div></div>)
    }*/

  const isMobile = window.innerWidth <= 500 ? true : false;
	
	return (isMobile ? (<>
    {((location[1] == "purchase") || (location[1]=="chats" && location[2]!=undefined)) || (location[1] == "vip_plan") || (location[1] == "unsubscribe") ? (<div ref={menuRef}></div>) : (<div>
        <menu ref={menuRef} className="menu_nuovo">
          {elementiMenu.map((elemento, index) => (
            <button
              key={index}
              className={`menu__item ${index === activeIndex ? 'active' : ''}`}
            
              onClick={() => handleClick(index,elemento)}
            >
              <svg className="icon" viewBox="0 0 24 24">
                {elemento === "find" && (
                  <>

							<path d="M18.125,15.804l-4.038-4.037c0.675-1.079,1.012-2.308,1.01-3.534C15.089,4.62,12.199,1.75,8.584,1.75C4.815,1.75,1.982,4.726,2,8.286c0.021,3.577,2.908,6.549,6.578,6.549c1.241,0,2.417-0.347,3.44-0.985l4.032,4.026c0.167,0.166,0.43,0.166,0.596,0l1.479-1.478C18.292,16.234,18.292,15.968,18.125,15.804 M8.578,13.99c-3.198,0-5.716-2.593-5.733-5.71c-0.017-3.084,2.438-5.686,5.74-5.686c3.197,0,5.625,2.493,5.64,5.624C14.242,11.548,11.621,13.99,8.578,13.99 M16.349,16.981l-3.637-3.635c0.131-0.11,0.721-0.695,0.876-0.884l3.642,3.639L16.349,16.981z"></path>

                  </>
                )}
                {elemento === "match" && (
                  <>
                  <svg fill="#fff" viewBox="0 0 296.555 296.555"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M295.683,96.043c-2.18-15.85-8.425-30.523-18.061-42.435c-8.948-11.063-20.564-19.295-32.71-23.182 c-8.976-2.867-17.831-4.32-26.328-4.32c-21.176,0-40.368,9.127-54.483,25.805c-15.504-16.939-33.672-25.522-54.064-25.523 c-7.944,0-16.223,1.357-24.607,4.035c-12.154,3.889-23.774,12.121-32.725,23.184c-9.639,11.912-15.886,26.588-18.066,42.439 c-0.45,3.271-0.722,6.58-0.824,9.92c-7.899,2.941-15.325,8.416-21.082,15.586c-6.579,8.191-10.8,18.248-12.207,29.082 c-2.234,17.207,2.685,35.756,14.226,53.643c12.819,19.867,33.815,39.189,62.405,57.432c2.624,1.674,5.616,2.512,8.606,2.512 c2.991,0,5.981-0.838,8.606-2.512c9.059-5.781,17.35-11.67,24.864-17.65c9.379,7.32,19.497,14.564,30.346,21.719 c4.632,3.057,10.021,4.674,15.581,4.674c5.559,0,10.946-1.615,15.582-4.672c43.654-28.793,75.516-59.029,94.699-89.873 C292.169,149.008,299.168,121.393,295.683,96.043z M40.506,120.571c4.269-1.363,8.238-1.981,11.932-1.981 c15.393,0,25.982,10.723,33.325,22.836c5.992-13.27,17.023-23.006,32.295-23.006c4.032,0,8.36,0.68,12.969,2.15 c26.176,8.379,53.592,64.572-45.264,127.648C-13.097,185.143,14.318,128.949,40.506,120.571z"></path> </g> </g></svg>
                  </>
                )}
                {elemento === "chats" && (
                  <>

                        <path d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z"/>
                        <path d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z"/>
                        

                  </>
                )}
                {elemento === "notifications" && (
                  <>
         <path stroke="#ffffff" d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </>
                )}
                {elemento === "profile" && (
                  <>
                 
                    <path fill="#fff" fill-rule="evenodd" d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z" clip-rule="evenodd"/>



                  </>
                )}
              </svg>
              {elemento === "chats" && (
                <span className="badge badge-danger navMob">{context.messaggiNonLetti}</span>
              )}
            </button>
          ))}
          <div ref={menuBorderRef} className="menu__border"></div>
        </menu>
  
        <div className="svg-container">
          <svg viewBox="0 0 202.9 45.5">
            <clipPath id="menu" clipPathUnits="objectBoundingBox" transform="scale(0.0049285362247413 0.021978021978022)">
              <path d="M6.7,45.5c5.7,0.1,14.1-0.4,23.3-4c5.7-2.3,9.9-5,18.1-10.5c10.7-7.1,11.8-9.2,20.6-14.3c5-2.9,9.2-5.2,15.2-7 c7.1-2.1,13.3-2.3,17.6-2.1c4.2-0.2,10.5,0.1,17.6,2.1c6.1,1.8,10.2,4.1,15.2,7c8.8,5,9.9,7.1,20.6,14.3c8.3,5.5,12.4,8.2,18.1,10.5 c9.2,3.6,17.6,4.2,23.3,4H6.7z" />
            </clipPath>
          </svg>
        </div>
      </div>)}
    </>):(<></>));

 }



